/* 共通の画面操作（モバイルメニュー・ダイアログ・カート数量の自動更新）。
   元：store.js の汎用部分。商品データを直書きしていた旧商品ページ用の処理は削除し、
   商品ページは sb-catalog-product.js が Liquid の出力（JSON）を読む。 */
(() => {
  "use strict";
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  function closeDialog(d) {
    d.close();
    document.body.classList.remove("modal-open");
  }

  $$("dialog.overlay").forEach((d) => {
    d.addEventListener("click", (e) => {
      if (e.target === d || e.target.closest("[data-close]")) closeDialog(d);
    });
    d.addEventListener("close", () => document.body.classList.remove("modal-open"));
  });

  function closeMobileNav() {
    $("#home-mobile-nav")?.classList.remove("open");
    $(".menu-button")?.setAttribute("aria-expanded", "false");
  }

  document.addEventListener("click", (e) => {
    const menu = e.target.closest(".menu-button");
    if (menu) {
      const nav = $("#home-mobile-nav");
      const expanded = menu.getAttribute("aria-expanded") !== "true";
      nav?.classList.toggle("open", expanded);
      menu.setAttribute("aria-expanded", String(expanded));
    }
    if (e.target.closest(".mobile-nav a")) closeMobileNav();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMobileNav();
  });

  /* カートページ：数量を変えたらフォームを送信して小計を更新する */
  document.addEventListener("change", (e) => {
    const input = e.target.closest("[data-cart-qty]");
    if (!input || !input.form) return;
    const value = Math.max(0, Math.trunc(Number(input.value) || 0));
    input.value = String(value);
    input.form.submit();
  });
})();
